<template>
  <GModal ref="modalImage" class="modal--image">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" @click.prevent="closeModal" />
      </button>

      <h2 class="modal-heading">Preview Image</h2>
    </div>

    <div slot="body">
      <template v-if="is_desktop">
        <figure class="image-preview gallery-preview">
          <img :src="previewImage.src" alt="" />
        </figure>
        <carousel
          ref="product-images-nav"
          :per-page="perPage"
          :pagination-enabled="is_desktop ? false : true"
          :pagination-active-color="is_desktop ? '' : '#F18B96'"
          :navigation-enabled="true"
          :navigation-next-label="''"
          :navigation-prev-label="''"
        >
          <template v-for="(productImage, i) in product.combinations">
            <slide v-for="(image_item, key) in productImage.images" :key="`${i + `-` + key}-productImages-thumbs`">
              <li
                :class="{
                  selected: previewImage.src === image_item.url,
                  filled: !image_item.url,
                }"
              >
                <a href @click.prevent="changeImage(productImage, image_item.url)">
                  <img :src="image_item.url" alt="" />
                </a>
              </li>
            </slide>
          </template>
        </carousel>
      </template>
      <template v-else>
        <carousel
          ref="preview-images"
          :per-page="1"
          :scroll-per-page="true"
          :pagination-enabled="false"
          @pageChange="pageChanged"
        >
          <template v-for="(productImage, i) in product.combinations">
            <slide v-for="(image_item, key) in productImage.images" :key="`${i + `-` + key}-productImages-thumbs`">
              <figure class="image-preview gallery-preview">
                <img v-if="previewImage.src" :src="image_item.url" />
              </figure>
            </slide>
          </template>
        </carousel>
        <div class="list-wrapper">
          <li
            v-for="(image_item, key) in allImages"
            :key="`${key}-productImages-child`"
            :class="{ filled: !image_item.url }"
            @click="goToSlide(key, image_item)"
          >
            <img :src="image_item.url" :class="{ selected: previewImage.src === image_item.url }" />
          </li>
        </div>
      </template>

      <div class="wrapper-modal-image">
        <p v-if="product && product.brand && product.brand.name" class="brand">
          {{ product.brand.name }}
        </p>
        <h1 class="title">{{ product.name }}</h1>
        <ul v-if="defaultPriceChanged || defaultPrice" class="price-info clearfix price-display-top">
          <li class="pricing hasdiscount">
            <span v-if="discountValue && isDiscountType && (defaultPrice || defaultPriceChanged)" class="ori"
              >Rp {{ (defaultPriceChanged ? defaultPriceChanged : defaultPrice) | currency }}</span
            >
            <span
              v-if="defaultPriceDiscount || defaultPriceDiscountChanged"
              :class="[
                discountValue && isDiscountType && (defaultPrice || defaultPriceChanged) ? 'after' : 'after-no-save',
              ]"
              >Rp
              {{ (defaultPriceDiscountChanged ? defaultPriceDiscountChanged : defaultPriceDiscount) | currency }}</span
            >
            <span
              v-else
              :class="[
                discountValue && isDiscountType && (defaultPrice || defaultPriceChanged) ? 'after' : 'after-no-save',
              ]"
              >Rp {{ (defaultPriceChanged ? defaultPriceChanged : defaultPrice) | currency }}</span
            >
          </li>
        </ul>
        <ul v-if="discountValue" class="price-info clearfix">
          <li class="pricing hasdiscount">
            <span v-if="isDiscountType == 'percentage'" class="save">-{{ discountValue }}%</span>
            <span v-if="isDiscountType == 'amount'" class="save">-Rp {{ discountValue | currency }}</span>
          </li>
        </ul>
      </div>
    </div>
  </GModal>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'modal-image',
  components: {
    Carousel,
    Slide,
  },
  props: {
    products: {
      type: Object,
      default: () => {},
    },
    currentCombination: {
      type: Object,
      default: () => {},
    },
    currentImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isChanged: false,
      image: '',
      isDiscountType: '',
      discountValue: '',
      defaultPriceDiscountChanged: '',
      defaultPriceChanged: '',
      selectedCobination: {},
      product: {},
    };
  },
  computed: {
    allImages() {
      const image = [];
      this.product.combinations.map((img) => {
        img.images.map((img2) => image.push({ url: img2.url, id: img._id, combination: img._id }));
      });
      return image;
    },
    previewImage() {
      if (this.isChanged) {
        return { src: this.image, id: this.selectedCobination._id };
      } else {
        if (Object.keys(this.currentCombination).length) {
          return { src: this.currentImage, id: this.currentCombination._id };
        } else {
          return {
            src: this.product.default_combination.images.find((x) => x.is_cover).url,
            id: this.product.default_combination._id,
          };
        }
      }
    },
    defaultPrice() {
      let result = 0;
      try {
        if (this.product.default_combination) {
          result = this.product.default_combination.price;
        } else {
          if (this.product.combinations && this.product.combinations.length) {
            const check = this.product.combinations.filter((value) => {
              result = value.default_on == 1;
            });

            if (check.length > 0) {
              result = check[0].price;
            } else {
              if (this.product.combinations[0] && this.product.combinations[0].price) {
                result = this.product.combinations[0].price;
              } else {
                result = this.product.price;
              }
            }
          } else {
            result = this.product.price;
          }
        }
      } catch (error) {}
      return result;
    },
    defaultPriceDiscount() {
      let result = 0;
      let activeCombination = null;
      try {
        if (this.isChanged) {
          activeCombination = this.selectedCobination;
        } else {
          activeCombination = this.selectedData;
        }
        if (activeCombination) {
          this.getDiscountType(activeCombination);
          result = activeCombination.price_after_discount;
        } else {
          const the_product = this.product;
          if (the_product.combinations && the_product.combinations.length) {
            const check = the_product.combinations.filter((value) => {
              result = value.default_on == 1;
            });
            if (check.length > 0) {
              this.getDiscountType(check[0]);
              result = check[0].price_after_discount;
            } else {
              if (the_product.combinations[0] && the_product.combinations[0].price_after_discount) {
                this.getDiscountType(the_product.combinations[0]);
                result = the_product.combinations[0].price_after_discount;
              } else {
                this.getDiscountType(the_product);
                result = the_product.price_after_discount;
              }
            }
          } else {
            this.getDiscountType(the_product);
            result = the_product.price_after_discount;
          }
        }
      } catch (error) {}
      return result;
    },
    perPage() {
      if (this.is_desktop === false) {
        if (window && window.innerWidth) {
          return Math.floor(window.innerWidth / 70);
        }
      }
      return 6;
    },
    is_desktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  watch: {
    products: {
      immediate: true,
      handler(newVal) {
        if (Object.keys(newVal).length) {
          const newProduct = JSON.parse(JSON.stringify(newVal));
          const imgs = newVal.combinations.some((img) => img.images.length);
          if (!imgs && newVal.combinations.length && newVal.images.length) {
            newProduct.combinations[0].images = newVal.images;
          }
          this.product = { ...newProduct };
        }
      },
    },
  },
  mounted() {
    document.documentElement.style.overflow = 'hidden';
  },
  methods: {
    closeModal() {
      this.$store.commit('setModalImage', false);
      document.documentElement.style.overflow = '';
    },
    goToSlide(index, image) {
      const comb = this.product.combinations.find((x) => x._id === image.combination);
      this.changeImage(comb, image.url);
      this.$refs['preview-images'].goToPage(index);
    },
    pageChanged(index) {
      try {
        const key = this.$refs['preview-images'].$slots.default[index].key;
        const comb_index = key.split('-')[0];
        const img_index = key.split('-')[1];
        this.changeImage(
          this.product.combinations[comb_index],
          this.product.combinations[comb_index].images[img_index].url
        );
      } catch (e) {
        console.log(e);
      }
    },
    changeImage(data, src) {
      this.isChanged = true;
      this.image = src;
      this.selectedCobination = Object.assign({}, data);

      let discount_type_combination = '';
      let discount_value_combination = '';

      if (data.deduction_type) {
        discount_type_combination = data.deduction_type;
        if (discount_type_combination == 'percentage') {
          discount_value_combination = data.deduction_percentage;
        } else {
          discount_value_combination = data.deduction_amount;
        }
      }
      if (data.price_after_discount) {
        this.defaultPriceDiscountChanged = data.price_after_discount;
      }

      this.isDiscountType = discount_type_combination;
      this.discountValue = discount_value_combination;
      this.defaultPriceChanged = data.price;
    },
    getDiscountType(combination) {
      if (combination && combination.deduction_type) {
        this.isDiscountType = combination.deduction_type;
        if (this.isDiscountType == 'percentage') {
          this.discountValue = combination.deduction_percentage;
        } else {
          this.discountValue = combination.deduction_amount;
        }
      } else {
        this.isDiscountType = '';
        this.discountValue = '';
      }
    },
  },
};
</script>
